import { render, staticRenderFns } from "./SectionVideos.vue?vue&type=template&id=66aea609&scoped=true&"
import script from "./SectionVideos.vue?vue&type=script&lang=js&"
export * from "./SectionVideos.vue?vue&type=script&lang=js&"
import style0 from "./SectionVideos.vue?vue&type=style&index=0&id=66aea609&scoped=true&lang=scss&"
import style1 from "./SectionVideos.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66aea609",
  null
  
)

export default component.exports